import React from "react";

export const LandingPage = () => {
  return (
    <div>
      <br/>
      <h4>C&ograve;mhradh is a free, online tool to learn Gaelic</h4>
      <p>
        It is designed to make full use of{" "}
        <strong>the potential of digital technology</strong> in language
        learning - not to simply be an online version of a course book.
      </p>
      <p>
        Lessons are designed as <strong>short-form</strong> content, to make
        most efficient use of your daily down-time. Each one is designed to be
        completed in one day and to fit in with your busy schedule.
      </p>
      <p>
        The course also makes use of the scientifically-proven{" "}
        <strong>spaced repetition</strong> method for learning - and remembering
        - vocabulary. As you progress throughout the course, the vocabulary you
        learn will be automatically added to a flashcard deck for you to revise.
      </p>
      <p>
        The <strong>pronunciation centre</strong> is designed to give you
        confidence in pronouncing words correctly and naturally, using
        innovative record-and-playback functions to allow you to compare your
        accent to the course.
      </p>
      <p>
        The course is designed based on hundreds of hours teaching Scottish
        Gaelic, and countless hours learning other languages. The goal is to
        avoid the pitfalls of traditional language learning methods and make
        full use of the potential of interactive digital technology and
        algorithms to do things that neither a course book or in-person lessons
        ever could.
      </p>
      <p>
        <strong>Log in to begin your journey now</strong>
      </p>
    </div>
  );
};
